import type { EntityConfig } from '../types'

export const clearingEntity: EntityConfig = {
  name: 'clearing',
  displayName: 'Clearing Entry',
  pluralName: 'Clearing Entries',
  status: {
    field: 'status',
    options: [
      { value: 'pending', label: 'Pending', color: 'warning' },
      { value: 'processing', label: 'Processing', color: 'info' },
      { value: 'cleared', label: 'Cleared', color: 'success' },
      { value: 'failed', label: 'Failed', color: 'error' },
    ],
    filters: [
      { label: 'All', value: 'all' },
      { label: 'Pending', value: 'pending' },
      { label: 'Processing', value: 'processing' },
      { label: 'Cleared', value: 'cleared' },
      { label: 'Failed', value: 'failed' },
    ],
    mappings: {
      all: ['pending', 'processing', 'cleared', 'failed'],
      pending: ['pending'],
      processing: ['processing'],
      cleared: ['cleared'],
      failed: ['failed'],
    },
  },
  queryFields: {
    status: { field: 'status', type: 'select', label: 'Status' },
    clearingHouse: { field: 'clearingHouse', type: 'select', label: 'Clearing House' },
  },
  uiFilterFields: ['status', 'clearingHouse'],
}
